import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Gutter } from './Gutter';
import styles from './ui.module.css';

/**
 * Окно вопроса: выйти из редактора, отклонить заявку, снести персонажа.
 *
 * Своё, а не вкуишные ModalRoot и Alert: у SplitLayout в App.tsx нет слотов
 * popout и modal, и заводить их ради одного вопроса значит перестраивать
 * каркас приложения.
 *
 * Рисуется ПОРТАЛОМ в document.body, и это не прихоть: внутри панели с
 * трансформацией (а View трансформирует панели на переходах) position: fixed
 * считается от панели, а не от экрана, и окно уезжало вместе с прокруткой.
 *
 * Следствие портала, на котором всё и сломалось: коробка оказывается СНАРУЖИ
 * корня VKUI, а цвет текста живёт именно на нём. Всё, что не красит себя само,
 * приезжает туда чёрным по тёмному — так и вышло с вкуишным заголовком. Отсюда
 * правило: окно называет и фон, и цвет текста, и заголовок у него свой.
 */
export function Dialog({
  title,
  children,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
}) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return createPortal(
    <div
      role="presentation"
      className={styles.dialogOverlay}
      // Закрывает только нажатие по самому фону, а не всплывшее из окна.
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <dialog open aria-modal="true" aria-label={title} className={styles.dialogBox}>
        <Gutter>
          <h2 className={styles.dialogTitle}>{title}</h2>
        </Gutter>
        {children}
      </dialog>
    </div>,
    document.body,
  );
}
